<template>
  <div role="checkbox" :class="[baseCss, disabled ? ['disabled', 'pointer-events-none'] : null]" :title="label">
    <label :class="['cursor-pointer', 'outline-none', 'block', 'w-full']">
      <table-layout :y-align="yAlign">
        <row>
          <cell x-align="center" :style="{width: `${iconSize}em`}" :class="['p-1']">
            <input
              type="checkbox"
              tabindex="-1"
              :id="id"
              :aria-checked="checked"
              :name="name"
              :checked="checked"
              :disabled="disabled"
              :class="['hidden']"
              @change="$emit('input', !checked)" /><icon
            :color="iconColor"
            :size="iconSize"
            :provider="iconProvider"
            :color-lightness="iconColorLightness"
            :name="indeterminate ? iconIndeterminate : checked ? iconChecked : iconBlank" /><span
            :class="['v-ripple', 'inline-block', 'align-middle', setBgColor('iconColor', 'iconColorLightness')]" />
          </cell>
          <cell x-align="left" :class="['pt-1', 'pr-1', 'pb-1']" v-if="label">
            <span v-html="label" :class="[internalLabelColor, `text-${labelSize}`, 'inline-block', 'align-middle', noWrapLabel ? ['whitespace-nowrap'] : null, truncateLabel ? 'truncate' : []]" />
          </cell>
        </row>
      </table-layout>
    </label>
  </div>
</template>
<script>
import methods from '../../mixins/methods'
import props from '../../mixins/props'

export default {
  name: 'Checkbox',
  mixins: [
    props,
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('checkbox', ['relative', 'inline-block', 'align-middle', 'select-none', 'cursor-pointer'])
    }
  },
  computed: {
    internalLabelColor () {
      return this.labelColor === 'black' ? this.$dark ? 'text-white' : 'text-black' : this.setTextColor('labelColor', 'labelColorLightness')
    }
  },
  model: {
    prop: 'checked',
    event: 'input'
  },
  props: {
    value: null,
    checked: null,
    yAlign: {
      type: String,
      default: 'middle',
      validator: value => {
        return ['top', 'middle', 'bottom', 'baseline', 'auto'].includes(value)
      }
    },
    noWrapLabel: {
      type: Boolean,
      default: true
    },
    truncateLabel: {
      type: Boolean
    },
    indeterminate: {
      type: Boolean
    },
    iconChecked: {
      type: String,
      default: 'checkbox-marked'
    },
    iconBlank: {
      type: String,
      default: 'checkbox-blank-outline'
    },
    iconIndeterminate: {
      type: String,
      default: 'minus-box'
    },
    labelColor: {
      type: String,
      default: 'black'
    },
    label: {
      type: String
    },
    iconColor: {
      type: String,
      default: 'black'
    },
    disabled: {
      type: Boolean
    },
    id: {
      type: String
    },
    name: {
      type: [String, Number]
    },
    iconSize: {
      type: Number,
      default: 1.5
    },
    labelSize: {
      type: String,
      default: 'sm',
      validator: value => {
        return ['xs', 'sm', 'base', 'lg', 'xl'].includes(value)
      }
    }
  },
  methods: {
    change () {
      const value = this.value
      if (this.checked.includes(value)) {
        this.checked.splice(this.checked.indexOf(value), 1)
      } else {
        this.checked.push(value)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/checkbox/checkbox.vue